// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKING!
export const VERSION = {
    "dirty": false,
    "raw": "v1.0.11-0-g6674680d",
    "hash": "g6674680d",
    "distance": 0,
    "tag": "v1.0.11",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v1.0.11",
        "major": 1,
        "minor": 0,
        "patch": 11,
        "prerelease": [],
        "build": [],
        "version": "1.0.11"
    },
    "suffix": "0-g6674680d",
    "semverString": "1.0.11",
    "version": "1.0.11",
    "versionDateTime": "2026-07-08T08:17:20.616Z"
};
